import React from 'react';
interface SectionHeaderProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
}
export function SectionHeader({
  title,
  description,
  action
}: SectionHeaderProps) {
  return <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6 gap-4" data-id="element-190">
      <div data-id="element-191">
        <h2 className="text-xl font-bold text-[#0F2044]" data-id="element-192">{title}</h2>
        {description && <p className="text-sm text-slate-500 mt-1" data-id="element-193">{description}</p>}
      </div>
      {action && <div data-id="element-194">{action}</div>}
    </div>;
}